/**
 * Contrato canónico: 5 templates con Mux + checkout.
 * Fuente única para hub, visitor links y validate-mux-membership-hub.mjs
 */

export interface MuxMembershipAdminLink {
  readonly to: string;
  readonly label: string;
}

export interface MuxMembershipPublicPath {
  readonly path: string;
  readonly label: string;
  readonly hint: string;
}

export interface MuxMembershipTemplateContract {
  readonly template: string;
  /** Una línea en cards del hub */
  readonly visitorRoutesLabel: string;
  readonly publicPaths: readonly MuxMembershipPublicPath[];
  readonly primaryPreview: string | null;
  readonly payment: string;
  readonly muxSource: string;
  readonly adminLinks: readonly MuxMembershipAdminLink[];
  readonly adminPreview?: string;
}

export const MUX_MEMBERSHIP_TEMPLATE_CONTRACT: readonly MuxMembershipTemplateContract[] = [
  {
    template: "VideoTemplate",
    visitorRoutesLabel: "/ home (intl · country-template asigna template)",
    publicPaths: [
      {
        path: "/",
        label: "Home",
        hint: "VideoTemplate en países con variante A/B en home",
      },
    ],
    primaryPreview: "/",
    payment: "Stripe · USD",
    muxSource: "Variante A/B · mux_playback_id por geo",
    adminLinks: [
      { to: "/admin/dual-cta-variants", label: "Variantes A/B" },
      { to: "/admin/country-template", label: "Template por país" },
    ],
    adminPreview: "/admin/preview/dual",
  },
  {
    template: "DualCTAVideoLanding",
    visitorRoutesLabel: "/membership · /ser-miembro · /invitacion-premium",
    publicPaths: [
      {
        path: "/membership",
        label: "Membership",
        hint: "DualCTAVideoLanding · Stripe (intl)",
      },
      {
        path: "/ser-miembro",
        label: "Ser miembro",
        hint: "DualCTAVideoLanding · Mercado Pago (AR)",
      },
      {
        path: "/invitacion-premium",
        label: "Invitación dual",
        hint: "DualCTAVideoLanding — no confundir con /premium-invite",
      },
    ],
    primaryPreview: "/membership",
    payment: "Stripe (intl) · MP (AR)",
    muxSource: "Variante geo (misma cascada que home video)",
    adminLinks: [
      { to: "/admin/dual-cta-variants", label: "Variantes A/B" },
      { to: "/admin/dual-cta-visibility", label: "VIP / Free" },
      { to: "/admin/stripe-checkout", label: "Stripe checkout" },
    ],
    adminPreview: "/admin/preview/dual",
  },
  {
    template: "BioTemplatePremium",
    visitorRoutesLabel: "/ home (país con BioTemplatePremium en country-template)",
    publicPaths: [
      {
        path: "/",
        label: "Home · Bio premium",
        hint: "BioTemplatePremium — Mux VIP + planes Stripe/MP",
      },
    ],
    primaryPreview: null,
    payment: "Stripe · MP",
    muxSource: "Env VITE_PREMIUM_MUX_* + membership_products VIP",
    adminLinks: [
      { to: "/admin/country-template", label: "Template por país" },
      { to: "/dashboard/subscripciones/planes", label: "Planes por nivel" },
    ],
  },
  {
    template: "BioTemplatePremiumSimple",
    visitorRoutesLabel: "/premium-invite",
    publicPaths: [
      {
        path: "/premium-invite",
        label: "Premium invite",
        hint: "BioTemplatePremiumSimple · Reels + overlay Mux",
      },
    ],
    primaryPreview: "/premium-invite",
    payment: "Stripe · MP",
    muxSource: "Admin Reels (playlist) + Premium Invite (overlay bio)",
    adminLinks: [
      { to: "/admin/reels", label: "Reels" },
      { to: "/admin/premium-invite-config", label: "Invitación premium" },
      { to: "/dashboard/subscripciones/planes", label: "Planes por nivel" },
    ],
    adminPreview: "/admin/reels",
  },
  {
    template: "MembresiaPremiumVip",
    visitorRoutesLabel: "/membresia-vip",
    publicPaths: [
      {
        path: "/membresia-vip",
        label: "Membresía VIP",
        hint: "MembresiaPremiumVip · ruta fija, sin variante geo",
      },
    ],
    primaryPreview: "/membresia-vip",
    payment: "Stripe · MP",
    muxSource: "Env VITE_PREMIUM_MUX_* (ruta fija)",
    adminLinks: [
      { to: "/dashboard/subscripciones/planes", label: "Planes VIP" },
      { to: "/admin/mercadopago-plans", label: "Planes MP" },
    ],
  },
] as const;

export const MUX_MEMBERSHIP_TEMPLATE_NAMES = MUX_MEMBERSHIP_TEMPLATE_CONTRACT.map(
  (row) => row.template,
);

/** Texto corto para paneles de experiencia — las 5 superficies en orden. */
export const MUX_MEMBERSHIP_SURFACE_SUMMARY =
  "VideoTemplate · DualCTAVideoLanding · BioTemplatePremium · BioTemplatePremiumSimple · MembresiaPremiumVip";